<template>
    <div ref="list" class="tw-space-y-4">
        <div class="tw-divide-y tw-divide-gray-50 tw-divide-solid">
            <div
                v-for="file in files.slice(0, maxAmountVisible)"
                :key="file._id"
                class="tw-border-0 tw-flex tw-justify-start tw-items-center tw-py-4 tw-cursor-pointer tw-text-gray-900 hover:tw-text-indigo-500 focus:tw-text-indigo-500"
                :class="{ 'tw-pb-0': files.length === 1 }"
                tabindex="0"
                @click="onDownload(file.key, $event)"
                @keyup.enter="onDownload(file.key, $event)"
            >
                <i class="fal fa-download tw-mr-2" />
                <div class="tw-truncate tw-max-w-xs">{{ file.title }}</div>
            </div>
        </div>

        <l-user-profile-load-more
            :items="files"
            :value.sync="maxAmountVisible"
            :max-amount-visible="6"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import api from "@/api";

import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";

export default {
    components: { LUserProfileLoadMore },
    props: {
        files: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            maxAmountVisible: 6,
        };
    },
    methods: {
        async onDownload(key, event) {
            event.preventDefault();

            try {
                const { data: uri } = await api.get(`/api/users/attachment/${key}`);
                window.open(uri, "_blank", "noopener noreferrer");
            } catch {
                // ignore
            }
        },
    },
};
</script>
